import type { Match } from '../../types/match'
import { requestApiJsonOrThrow } from '../request-handler'

type GetMatchCentreMatchesParams = {
  startdate?: string
  enddate?: string
  isLive?: boolean
}

function getMatchCentreMatches(params: GetMatchCentreMatchesParams): Promise<Match[]> {
  return requestApiJsonOrThrow<Match[]>('matches', {
    params: {
      startdate: params.startdate,
      enddate: params.enddate,
      isLive: params.isLive ? 'true' : undefined,
    },
  })
}

export const matchCentreMatchesQuery = (params: GetMatchCentreMatchesParams) => ({
  queryKey: ['match-centre-matches', params],
  queryFn: () => getMatchCentreMatches(params),
})
